import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Bounce } from 'react-reveal';
import { NavLink, useParams } from 'react-router-dom';
import { Button,  Icon, Popup} from 'semantic-ui-react';
import SKLT from '../../AssetsM/usedSlk';
import GConf from '../../AssetsM/generalConf';
import BreadCrumb from '../Assets/breadCrumb'
import { toast } from 'react-toastify';
import FrameForPrint from '../Assets/frameForPrint';
import usePrintFunction from '../Assets/Hooks/printFunction';
import { Input } from 'semantic-ui-react';
 

function FactureInfo() {
    /*#########################[Const]##################################*/
    const {FID} = useParams()
    const [articleL, setArticleL] = useState([])
    const [factureData, setFactData] = useState({Final_Value : 0})
    const [client, setClient] = useState('Passager')
    const [loading , setLoading] = useState(false)
    const [toUpdatedList, setTUpList] = useState([])
     
    
    /*#########################[UseEffect]##################################*/
    useEffect(() => {
        axios.post(`${GConf.ApiLink}/facture/select`, {
            PID : GConf.PID,
            fid: FID
          })
          .then(function (response) {
                if(!response.data[0]) {
                    toast.error('Facture Introuvable !', GConf.TostSuucessGonf)
                    setTimeout(() => {  window.location.href = "/S/ft"; }, 2000)
                    
                } else {
                    setFactData(response.data[0])
                    setArticleL(JSON.parse(response.data[0].Articles))
                    let UsedTableNow = []
                    JSON.parse(response.data[0].Articles).map( (article) => {UsedTableNow.push([article.A_Code, article.Qte ])} )
                    setTUpList(UsedTableNow)
                    setLoading(true)
                     
                }    
          }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5>   </div></>, GConf.TostInternetGonf)   
               
            }
          });

           

    }, [])

    /*#########################[Function]##################################*/
    const PrintFunction = (frameId) =>{ usePrintFunction(frameId)}
    const MarkAsPayee = () =>{
        axios.post(`${GConf.ApiLink}/facture/modifier-terminer`, {
            FID : FID,
          })
          .then(function (response) {      
            toast.success("Facture Payee !", GConf.TostSuucessGonf)
          }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Operation Annuleé  </div></>, GConf.TostInternetGonf)   
            }
          });

    }
 
    const CalculateTVA =  (value) =>{
        const facteur_p = (100 / (GConf.DefaultTva + 100));
        return (parseFloat(value) * facteur_p).toFixed(3) 
    }
 
 
    /*#########################[Card]##################################*/
    const StateCard = ({ status }) => {
        const StateCard = (props) =>{ return <span className={`badge bg-${props.color}`}> {props.text} </span>}
        const statusCard = React.useCallback(() => {
          switch(status) {
            case 'T': return <StateCard color='success' text='Termineé' />;  
            case 'R': return <StateCard color='danger' text='Retour' /> ;
            case 'W': return <StateCard color='warning' text='En Cours' /> ;
            case 'P': return <StateCard color='primary' text='Payeé' /> ;
            default:  return <StateCard color='secondary' text='Indefinie' />;    
          }
        }, [status]);
      
        return (
          <div className="container">
            {statusCard()}
          </div>
        );
    }
    const FactureHeader = () =>{
        return(<>
                <h2 className='text-center'>Facture Client </h2> 
                <div className='row'>
                    <div className='col-6'>
                         
                        <div className='text-secondary'><b>CODE FACTURE : </b> {FID}</div>
                        <div className='text-secondary'><b>CLIENT: {factureData.Client} </b> </div>
                        <div className='text-secondary'><b>TEL: {factureData.Phone} </b> </div>
                        <div className='text-secondary'><b>CIN: {factureData.CIN} </b> </div>
                         
                    </div>
                    <div className='col-6'>
                        <div className='text-danger'><b>DE : </b> {new Date(factureData.T_Date).toLocaleDateString('fr-FR').split( '/' ).reverse( ).join( '-' )} </div>
                        <div className='text-danger'><b>VERS : </b> {new Date(factureData.R_Date).toLocaleDateString('fr-FR').split( '/' ).reverse( ).join( '-' )} </div>
                    </div>
                </div>
        </>)
    }
    const TotaleCard = () =>{
        return(<>
                <div className='card card-body shadow-sm mb-2'>
                    <div className='row'>
                        <div className='col-6'>
                            <h5 className='mb-0'>Totale </h5>
                            <h2 className='text-danger mt-1'><b>{loading ? parseFloat(factureData.Final_Value).toFixed(3) : SKLT.BarreSkl } </b></h2>
                        </div>
                        <div className='col-6 align-self-center'>
                            <h2 className='text-end mt-1'><StateCard status={factureData.State} /></h2>
                        </div>
                    </div>
                                        
            </div>
        </>)
    }
    const BtnsCard = () =>{
        return(<>
                <div className='card card-body shadow-sm mb-2'>
                    <h5>Controle</h5>
                    <div className='row mb-2'>
                    
                    <div className='col-6'>
                        <Button  className='rounded-pill btn-imprimer'  fluid onClick={(e) => PrintFunction('printFacture')}><Icon name='print' /> Imprimer</Button>
                    </div>
                    <div className='col-6'>
                        <Button  className='rounded-pill bg-danger text-white'  fluid onClick={(e) => PrintFunction('printFacture')}><Icon name='trash' /> Supprimer</Button>
                    </div>
                    </div>
                    <div className='row mb-2'>
 
                        <div className='col-12 mt-2'>
                            <Button  className='rounded-pill  btn-regler'  fluid   onClick={() => MarkAsPayee()}><Icon name='check circle' /> TERMINER </Button>
                        </div>
                    </div>
                    <hr />
                    <div className='row mb-2'>
                        <div className='col-12'>
                            <Button  className='rounded-pill bg-primary text-white'  fluid onClick={() => alert(5)}><Icon name='edit outline' /> Modifier </Button>
                        </div>
                         
                    </div>

                </div>
        </>)
    }
    
    return ( <> 
        <BreadCrumb links={GConf.BreadCrumb.factureInfo} />
        <br />
        <div className="row">
            <div className="col-12 col-lg-8">
                
                <FactureHeader />
                <br />
                <br />
                <table className="table">
                    <thead>
                        <tr>
                        <th scope="col">No</th>
                        <th scope="col">Designiation</th>
                        <th scope="col">Qté</th>
                        <th scope="col">Prix</th>
                        <th scope="col">Totale</th>
                        </tr>
                    </thead>
                    <tbody>
                        
                        {loading ?  
                        <>
                        {articleL.map( (artData, index) => 
                            <tr key={index +1 }>
                                <th scope="row">{index +1 }</th>
                                <td>{artData.Name}</td>
                                <td>{artData.Qte}</td>
                                <td>{CalculateTVA(artData.Prix)}</td>
                                 
                                <td>{artData.PU}</td>
                            </tr>
                        )}
                        
                        </>
                        : SKLT.FactureList }                        
                        
                    </tbody>
                </table>
                 
            </div>
            <div className="col-12 col-lg-4">
            <Bounce bottom>
                <div className="sticky-top" style={{top:'70px'}}>
                    <TotaleCard />
                     
                    <BtnsCard />
                     
                </div>
            </Bounce>
            </div>
        </div>
        <FrameForPrint frameId='printFacture' src={`/Pr/facture/${FID}`} />
    </> );
}

export default FactureInfo;